import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import cachingService from '../../services/caching_service';
import request from '../../utils/request_util';
import Base from '../base_model';
import log from '../../services/logger_service';

export default class MicSector extends Base {
  static fetch({ year }, store) {
    const cleanedYear = this.cleanParam(year);

    if (cleanedYear < 2020 && cleanedYear > 2007) {
      const state = store.getState();
      const cacheEnabled = get(state, 'config.cacheEnabled');
      const cacheExpire = get(state, 'config.cacheExpire');
      const cacheNamespace = get(state, 'config.cacheNamespace');
      const host = 'assets.fastcompany.com';
      const options = {};
      const cacheKeyUrl = `https://${host}/multisite_files/fastcompany/mic/json/sectors/mic_${cleanedYear}_sectors.json`;
      const cacheKey = `${cacheNamespace}:${cacheKeyUrl}`;

      if (!cacheEnabled) {
        return request.getAsync(cacheKeyUrl, options);
      }

      return cachingService
        .getAsync(cacheKey)
        .then(function fromCache(cacheRes) {
          if (cacheRes) {
            return Promise.resolve(JSON.parse(cacheRes));
          }

          if (!canUseDOM) {
            log.info(`Requesting: ${cacheKeyUrl} from model.`);
          }

          return request
            .getAsync(cacheKeyUrl, options)
            .then(function fetchSuccess(resp) {
              cachingService.setex(cacheKey, cacheExpire, JSON.stringify(resp));
              return resp;
            });
        });
    }
    return Promise.reject(new Error('Invalid Years'));
  }
}
